import React from 'react';
import { Badge } from 'react-bootstrap';

/**
 * Component to display Pokemon types with proper styling
 * @param {Object} props
 * @param {string} props.type - The primary type of the Pokemon
 * @param {string} props.secondaryType - The secondary type of the Pokemon (optional)
 * @param {string} props.size - Size of the badge (sm, md, lg)
 */
const PokemonTypeDisplay = ({ type, secondaryType, size }) => {
  if (!type) return null;

  // Map type names to their corresponding colors
  const getTypeColor = (typeName) => {
    const typeMap = {
      'grass': 'success',
      'poison': 'purple',
      'fire': 'danger',
      'water': 'primary',
      'electric': 'warning',
      'ice': 'info',
      'fighting': 'danger',
      'ground': 'warning',
      'flying': 'info',
      'psychic': 'danger',
      'bug': 'success',
      'rock': 'secondary',
      'ghost': 'dark',
      'dragon': 'primary',
      'dark': 'dark',
      'steel': 'secondary',
      'fairy': 'pink',
      'normal': 'light'
    };
    
    return typeMap[typeName.toLowerCase()] || 'secondary';
  };

  const renderTypeBadge = (typeName) => {
    return (
      <Badge 
        bg={getTypeColor(typeName)} 
        className={`type-icon type-${typeName.toLowerCase()} m-1`}
        style={{
          fontSize: size === 'lg' ? '1.2rem' : size === 'sm' ? '0.8rem' : '1rem',
          padding: size === 'lg' ? '0.5rem 0.8rem' : size === 'sm' ? '0.2rem 0.4rem' : '0.3rem 0.6rem'
        }}
      >
        {typeName}
      </Badge>
    );
  };

  return (
    <div className="d-inline-flex">
      {renderTypeBadge(type)}
      {secondaryType && renderTypeBadge(secondaryType)}
    </div>
  );
};

export default PokemonTypeDisplay; 